import { render } from "./AdditionalCharges.vue?vue&type=template&id=177c4b17&scoped=true"
import script from "./AdditionalCharges.vue?vue&type=script&lang=js"
export * from "./AdditionalCharges.vue?vue&type=script&lang=js"

import "./AdditionalCharges.vue?vue&type=style&index=0&id=177c4b17&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177c4b17"]])

export default __exports__